import PropTypes from 'prop-types'
import dayjs from 'dayjs'
import { Box, Stack, Tooltip, Typography } from '@mui/joy'
import { AttachFile, FileDownload } from '@mui/icons-material'
import useTaskFileDownloader from 'hooks/useTaskFileDownloader'
import { DATE_FORMAT, DATE_TIME_FORMAT } from 'utils/config'

const UserResultDownloadTooltip = ({ userFiles, iconColor = 'primary', sx }) => {
  const { downloadTaskFile } = useTaskFileDownloader()

  if (userFiles.length === 0) return '-'

  return (
    <Tooltip
      variant="outlined"
      arrow
      title={
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            maxWidth: 320,
            justifyContent: 'center',
            p: 1,
          }}
        >
          <Box sx={{ display: 'flex', gap: 1, width: '100%', mt: 0 }}>
            <Stack spacing={1}>
              <Typography level="title-sm" title={dayjs(userFiles[0].createdAt).format(DATE_TIME_FORMAT)}>
                Data przesłania: {dayjs(userFiles[0].createdAt).format(DATE_TIME_FORMAT)}
              </Typography>
              {userFiles.map((file) => (
                <Box key={file.id} sx={{ display: 'flex', marginTop: 1 }}>
                  <Typography
                    level="body-sm"
                    onClick={() => downloadTaskFile(file)}
                    startDecorator={<FileDownload color={iconColor} fontSize="inherit" />}
                    sx={{
                      cursor: 'pointer',
                      '&:hover': {
                        textDecoration: 'underline',
                      },
                    }}
                  >
                    <Typography color="primary">{file.fileName}</Typography>
                  </Typography>
                </Box>
              ))}
            </Stack>
          </Box>
        </Box>
      }
    >
      <Typography
        underline="none"
        sx={[{ display: 'flex', alignItems: 'center', justifyContent: 'center' }, ...(Array.isArray(sx) ? sx : [sx])]}
        startDecorator={<AttachFile color={iconColor} fontSize="inherit" />}
      >
        Pliki ({userFiles.length})
      </Typography>
    </Tooltip>
  )
}

UserResultDownloadTooltip.propTypes = {
  userFiles: PropTypes.array.isRequired,
  iconColor: PropTypes.string,
  children: PropTypes.node,
  sx: PropTypes.object,
}

export default UserResultDownloadTooltip
